import { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar } from 'recharts';
// import { BarChart, Bar,  XAxis, YAxis, CartesianGrid } from 'recharts';
// import { LineChart, Line, Legend } from 'recharts';
import { useReportsDeals } from '../../hooks/useReportsDeals';
// import { FunnelChart, Funnel, LabelList } from 'recharts';




const COLORS = ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4'];

export default function Dashboard() {
  // const [data, setData] = useState<DashboardData>(mockData);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('2025-10-01');
  const [endDate, setEndDate] = useState('2025-10-31');
  const [selectedAgent, setSelectedAgent] = useState<string>("");
  // const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  // const [showAgentDropdown, setShowAgentDropdown] = useState(false);
  // const [showStatusDropdown, setShowStatusDropdown] = useState(false);

  // const { dataTotal, dataLeads, dataSource, dataActivity, dataProgram, dataStatus, dataUsers } = useReportsDeals({ start_date: startDate, end_date: endDate, user_id: selectedAgent });

  const { dataLeads, dataSource, dataActivity, dataStatus, dataUsers } = useReportsDeals({ start_date: startDate, end_date: endDate, user_id: selectedAgent });


  // Función para cargar datos del backend
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
    } catch (error) {
      console.error('Error:', error);
      // setData(mockData);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-xl text-gray-600">Cargando datos...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Dashboard de Rendimiento</h1>
          <p className="text-gray-600">Análisis de Deals</p>
        </div>

        {/* Filters Section */}
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Filtros</h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Inicio</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Fin</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Seleccionar Agente
              </label>
              <select
                value={selectedAgent}
                onChange={(e) => setSelectedAgent(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Todos los agentes</option>
                {dataUsers.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.full_name}
                  </option>
                ))}
              </select>
            </div>

          </div>

        </div>






        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Deals por status</h2>
            </div>

            <div className="flex flex-col lg:flex-row items-center gap-6">

              <div className="flex-1 w-full">
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={dataStatus}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="count"
                    >
                      {dataStatus.map((entry, index) => (
                        <Cell
                          key={`cell-${index}-${entry.status_id}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value: number) => [
                        `${value} `
                      ]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              <div className="flex flex-col gap-2 lg:w-1/3">
                {dataStatus.map((entry, index) => (
                  <div
                    key={`legend-${entry.status_id}`}
                    className="flex items-center gap-2 text-xs"
                  >
                    <div
                      className="w-4 h-4 rounded flex-shrink-0"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    />
                    <span className="text-gray-700">
                      {entry.status_name}: <span className="font-semibold">{entry.count}</span> ({entry.percentage}%)
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
 

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Fuentes de Deals</h2>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={dataSource} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="source_name" type="category" width={100} />
                <Tooltip />
                <Bar dataKey="deal_count" fill="#3b82f6">
                  {dataSource.map((entry, index) => (
                    <Cell key={`cell-${index}-${entry.source_id}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Detalle de Actividades por Agente</h2>
          <div className="space-y-6">
            {dataActivity.map((activity, idx) => (
              <div key={idx} className="border-l-4 border-blue-500 pl-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg text-gray-800">{activity.user_name}</h3>
                  <span className="text-sm font-medium text-gray-600">Total: {activity.total_activities}</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {activity.activities_by_type.map((type, i) => (
                    <div key={i} className="bg-gray-50 rounded p-3">
                      <p className="text-xs text-gray-600">{type.type_name}</p>
                      <p className="text-lg font-semibold text-gray-900">{type.count}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>


        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Flujo Detallado por Etapa y Status</h2>
          <div className="space-y-6">
            {dataLeads.map((stage, idx) => (
              <div key={idx} className="border-l-4 border-blue-500 pl-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg text-gray-800">{stage.process_name}</h3>
                  <span className="text-sm font-medium text-gray-600">Total: {stage.total_deals_in_process}</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {stage.statuses.map((status, i) => (
                    <div key={i} className="bg-gray-50 rounded p-3">
                      <p className="text-xs text-gray-600">{status.status_name}</p>
                      <p className="text-lg font-semibold text-gray-900">{status.deal_count}</p>
                      <p className="text-xs text-gray-500">
                        {status.percentage_of_process} %
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </div>
  );
}